import dayjs from "dayjs";

/**
 * Sort surveys by oldest first (by start date)
 */
export const sortSurveysByOldestFirst = (surveys: any[]): any[] => {
    if (!surveys || surveys.length === 0) return [];
    
    try {
        return [...surveys].sort((a, b) => {
            const dateA = a?.dates?.start ? dayjs(a.dates.start).valueOf() : 0;
            const dateB = b?.dates?.start ? dayjs(b.dates.start).valueOf() : 0;
            return dateA - dateB;
        });
    } catch (error) {
        console.error("Error sorting surveys:", error);
        return surveys || [];
    }
};

/**
 * Transform surveys to location data format for map
 * Expected format: [{ lat, long }]
 */
export const transformSurveysToLocations = (surveys: any[]): Array<{ lat: number; long: number }> => {
    if (!surveys || surveys.length === 0) return [];
    
    try {
        return surveys
            .filter((survey) => survey && (survey.lat || survey.lat === 0) && (survey.long || survey.long === 0))
            .map((survey) => {
                const lat = typeof survey.lat === "number" ? survey.lat : parseFloat(survey.lat);
                const long = typeof survey.long === "number" ? survey.long : parseFloat(survey.long);
                return { lat, long };
            })
            .filter((loc) => !isNaN(loc.lat) && !isNaN(loc.long));
    } catch (error) {
        console.error("Error transforming surveys to locations:", error);
        return [];
    }
};

